(function () {
  'use strict';

  class TestimonialsCardSlider {
    constructor(el) {
      this.el     = el;
      this.scroll = el.querySelector('[data-tcs-scroll]');
      if (!this.scroll) return;
      this._attachProgress(this.scroll);
      this._bindDrag(this.scroll);
    }

    _attachProgress(scroll) {
      const next = scroll.nextElementSibling;
      const wrapper = (next && next.classList.contains('tcs-progress'))
        ? next
        : (() => {
            const el = document.createElement('div');
            el.className = 'tcs-progress';
            el.innerHTML = '<div class="tcs-progress__bar"><div class="tcs-progress__thumb"></div></div>';
            scroll.after(el);
            return el;
          })();

      const thumb = wrapper.querySelector('.tcs-progress__thumb');
      const bar   = wrapper.querySelector('.tcs-progress__bar');

      const update = () => {
        const maxScroll = scroll.scrollWidth - scroll.clientWidth;
        if (maxScroll <= 0) { wrapper.style.display = 'none'; return; }
        wrapper.style.display = '';
        const barW   = bar.offsetWidth;
        const ratio  = scroll.clientWidth / scroll.scrollWidth;
        const thumbW = Math.max(20, Math.round(barW * ratio));
        const thumbL = Math.round((barW - thumbW) * (scroll.scrollLeft / maxScroll));
        thumb.style.width = thumbW + 'px';
        thumb.style.left  = thumbL + 'px';
      };

      scroll.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(scroll);
      window.addEventListener('load', update, { once: true });
      update();
    }

    _bindDrag(scroll) {
      let startX = 0, startScrollLeft = 0;

      scroll.addEventListener('pointerdown', e => {
        startX = e.clientX;
        startScrollLeft = scroll.scrollLeft;
        scroll.setPointerCapture(e.pointerId);
        scroll.classList.add('is-dragging');
      });

      scroll.addEventListener('pointermove', e => {
        if (!scroll.classList.contains('is-dragging')) return;
        scroll.scrollLeft = startScrollLeft - (e.clientX - startX);
      });

      const stop = () => scroll.classList.remove('is-dragging');
      scroll.addEventListener('pointerup', stop);
      scroll.addEventListener('pointercancel', stop);
    }
  }

  function init() {
    document.querySelectorAll('[data-tcs-section]').forEach(el => new TestimonialsCardSlider(el));
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
